<template>
  <div class="m-money-dialog dialog">
    <div class="digest">
      <p class="top">
        <span>主题：</span>
        <span class="switch-btn" @click="switchHandle">切换主题</span>
      </p>
      <div class="content-box">
        <p class="broadcast-content">{{ info.txt }}</p>
      </div>
    </div>
    <div class="input-box">
      <el-input size="small" type="number" step="1" min="5" v-model.number="money">
        <template slot="prepend">红包总额</template>
      </el-input>
      <el-input size="small" type="number" min="10" step="1" placeholder="" v-model="qty">
        <template slot="prepend">红包个数</template>
      </el-input>
      <div class="total-box">
        <p>
          <span class="label">合计: </span><span class="price">¥{{ total }}</span>
        </p>
        <p style="font-size: 12px;">(¥{{ (this.money || 0).toFixed(2) }} + ¥{{ (this.money * 0.2).toFixed(2) }})</p>
      </div>
      <div class="tip-box">
        <pre>
红包规则：
1.发红包个数必须10至100个,总额不可低于5元
2.未领取的红包,将于24小时后发起退款
3.将收取 0.2 * 红包总额的服务费</pre
        >
      </div>
      <el-button type="warning" :loading="loading" @click="payment">塞钱进红包</el-button>
    </div>
  </div>
</template>
<script>
import Pay from "@/api/pay";
import Bus from "@/components/Bus";
export default {
  data() {
    return {
      qrVisible: false,
      money: 5,
      qty: 10,
      loading: false,
      url: "",
      base64: ""
    };
  },
  computed: {
    total() {
      if (this.money) {
        return (this.money + this.money * 0.2).toFixed(2) || 0;
      } else {
        return 0;
      }
    },
    redEnvelopeInfo() {
      return this.$store.state.redEnvelopeInfo;
    },
    userId() {
      return this.$store.state.userId;
    }
  },
  watch: {
    redEnvelopeInfo(newValue) {
      if (newValue.id === this.userId) {
        this.$emit("update:visible", false);
      }
    }
  },
  methods: {
    async payment() {
      // if (
      //   (this.money < 5 || this.money / this.qty < 0.05) &&
      //   process.env.NODE_ENV === "production"
      // ) {
      //   this.$toast.fail("红包总价不能低于5元，单个红包金额不能低于0.05元");
      //   this.base64 = "";
      //   return false;
      // }
      await Pay.redEnvelope({
        id: this.info.msgId,
        money: this.money,
        qty: this.qty
      }).then(res => {
        Bus.$emit("showPayQR", res.PayUrl);
        this.$emit("update:visible", false);
      });
    }
  },
  props: {
    visible: Boolean,
    info: Object,
    switchHandle: {
      type: Function,
      default: null
    }
  }
};
</script>
<style lang="scss">
.m-money-dialog {
  position: relative;
}
</style>
